var _rect, _path, _path2, _g, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfGuyana({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 118,
    viewBox: "0 0 177 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2764_6306)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 118,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H177V118H0V0Z",
    fill: "#2A936A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2764_6306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 177,
    height: 118
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L177 59L0 118V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2764_6306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L177 59L0 118",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L177 59L0 118",
    stroke: "white",
    strokeWidth: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2764_6306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 118
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L88.5 59L0 118V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2764_6306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L88.5 59L0 118",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L88.5 59L0 118",
    stroke: "black",
    strokeWidth: 40
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2764_6306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 118,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfGuyana);
export default __webpack_public_path__ + "static/media/Flag_of_Guyana.7f11210fe4183e59436acefd8d490b64.svg";
export { ForwardRef as ReactComponent };